import { Empty, EmptyProps } from "antd";
import EmptyImage from "../../assets/images/empty.svg";

export default function CustomEmpty({ imageStyle, ...rest }: EmptyProps) {
  return (
    <Empty
      image={EmptyImage}
      imageStyle={{ marginBottom: 0, ...imageStyle }}
      description
      {...rest}
    />
  );
}
